<template>
  <div>  
    <EditViewForm 
      :handle_dynamic_form_update="()=>{}"
      :handle_file_upload="()=>{}"
      :page_structure="page_structure"
      :preloaded_data="metadata"
      mode="view"
    />
  
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('cancel')">離開</el-button>
    </span>
    <LoadingBlock :active="loading"></LoadingBlock>
  </div>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import LoadingBlock from '@/components/backstage/LoadingBlock/LoadingBlock.vue'
import DetailStructure from '@/views/backstage/structure/digital_object_page/DigitalObjectDetailPageStructure'
import EditViewForm from '@/components/backstage/EditViewForm/EditViewForm.vue'

  export default {
    components: {
      LoadingBlock,
      EditViewForm
    },
    props: [
        'mode','resource_name','resource_identifier','host_resource_identifier','route_root','type','dialog_visible','dialog_refersh'],
    data() {
      return {
        loading: false,//TODO: change this to true
        active_tab_name: 'metadata',
        page_structure: [],
        edit_structure: [],
        metadata: {}, 
        file_lists: {},
        inner_mode: 'view',
        resource_api: process.env.VUE_APP_API_BACKSTAGE_URL + '/' + this.resource_name,
      }
    },
    watch:{
      resource_identifier: function (val) {
        this.init()
      },
      mode: function (val) {
        this.init()
      },
      dialog_visible: function () {
        this.init()
      }
    },
    created: function () {
      this.init()
    },
    methods: {
      init () {
        console.log('DigitalObjectDetailPage: digital object, type:', this.type)
        console.log('DigitalObjectDetailPage: digital object, resource_identifier:', this.resource_identifier)

        if (!this.type || !this.resource_identifier) {
          this.notify_message(this.ERROR.LEVEL.ERROR, '沒有數位物件的類型或編號')
          return 
        }

        if (this.mode !== 'view') {
          this.notify_message(this.ERROR.LEVEL.ERROR, '數位物件檢視模式錯誤')
          return 
        }

        this.inner_mode = this.mode

        this.page_structure = DetailStructure(this.type)
        console.log('DigitalObjectDetailPage: digital object, page structure:', this.page_structure)    

        let metadata_temp = this.forge_context_container(this.page_structure)

        this.metadata = JSON.parse(JSON.stringify(metadata_temp))

        this.file_lists = {}

        this.get_metadata()
      },
      get_metadata () {

        if (this.inner_mode === 'add') {
          console.log('DigitalObjectDetailPage: in "add" mode, skip data retrieving')
          return
        }

        if (typeof this.resource_identifier['value'] === 'undefined' || this.resource_identifier['value'] === null) {
          console.log('warn: DigitalObjectDetailPage: insufficient info to get digital object')
          this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得數位物件', '沒有數位物件的編號')
          return
        }

        this.loading = true
        let params = {}
        params[this.resource_identifier['name']] = this.resource_identifier['value']
        
        axios.get(this.resource_api+'/get', {params})
            .then((response) => {
              this.loading = false
              console.log('DigitalObjectDetailPage: GET: response: ', response.data.payload)
              if (response.data.success) {
                this.metadata = this.translate_to_display_data(this.page_structure, response.data.payload)

                // foreign key
                this.metadata[this.foreign_key] = response.data.payload[this.foreign_key]
              }
              else {
                this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得數位物件', response.data.message)
              }
            })
            .catch(err => {
                this.loading = false
                console.log(err)
                this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得數位物件', this.ERROR.MSG.general_err_msg)
            })
      },
    },
  };
</script>

<style lang="scss" scoped>

.action_buttons {
  float: right;
  .el-button {
    margin-right: 22px;
  }
}

.choices-radio{
  margin-bottom: 22px;
}

.clearfix::after {
    content: "";
    clear: both;
    display: table;
}

.field {
  width: 300px;
}
</style>
